import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Form, Input, Button, Checkbox, Modal } from "antd";
import { UserOutlined, KeyOutlined } from "@ant-design/icons";
import KnackLogo from "../../assets/images/knackLogo.png";
import LoginService from "../../services/login-service";
import { NotificationManager } from "react-notifications";
import { setLoginDetails } from "../../actions/login/LoginAction";
import "./login.css";
import useEncryptData from "../../utils/EncryptData";
import Cookies from "js-cookie";
import {
  checkIsMobileDevice,
  isDeviceIos,
} from "../../helper/checkIsMobileDevice";

const Login = () => {
  const [form] = Form.useForm();
  const [resetForm] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const EncryptData = useEncryptData();

  const [activeTab, setActiveTab] = useState("customer");
  const [isRememberMe, setIsRememberMe] = useState(false);
  const [isResetModalVisible, setIsResetModalVisible] = useState(false);
  const [hrmsCode, setHrmsCode] = useState("");

  useEffect(() => {
    const rememberedUsername = Cookies.get("rememberedUsername");
    const rememberedPassword = Cookies.get("rememberedPassword");
    if (rememberedUsername) {
      form.setFieldsValue({
        email: rememberedUsername,
        password: rememberedPassword,
        remember: true,
      });
    }
  }, [form]);

  const handleTabOnchange = (tab) => {
    setActiveTab(tab);
    form.setFields(
      form.getFieldsError().map(({ name }) => ({
        name,
        errors: [],
      }))
    );
  };

  //// handle Login API called
  const handleLoginSubmit = (values) => {
    if (values.remember) {
      Cookies.set("rememberedUsername", values.email, { expires: 7 });
      Cookies.set("rememberedPassword", values.password, { expires: 7 });
    } else {
      Cookies.remove("rememberedUsername");
    }
    localStorage.removeItem("Company_Code");
    let inputData = {
      email: values.email.trim(),
      password: values.password,
      isEmployee: activeTab === "customer" ? false : true,
    };
    LoginService.login(inputData)
      .then((response) => {
        if (response.data.statusCode === 200) {
          let finalResponse = response.data.responseData;
          let originalToken = finalResponse.token;
          let EncryptToken = EncryptData(finalResponse.token);
          finalResponse.token = EncryptToken;
          finalResponse.isHRMSActive = true;
          setHrmsCode(finalResponse.userDetails.hrmS_Code);
          console.log(finalResponse.userDetails.hrmS_Code);
          if (finalResponse?.userDetails?.needToPasswordReset) {
            setIsResetModalVisible(true);
            return;
          }
          localStorage.setItem("token", EncryptToken);
          localStorage.setItem("selectedAnalysisType", "C");
          dispatch(setLoginDetails(finalResponse));
          // if (checkIsMobileDevice()) {
          //   const redirectUrl = `${
          //     process.env.REACT_APP_HRMS_URL
          //   }?token=${encodeURIComponent(originalToken)}`;
          //   if (isDeviceIos) {
          //     window.location.href = redirectUrl;
          //   } else {
          //     window.open(redirectUrl, "_blank");
          //   }
          // } else {
          navigate("/galaxyHome");
          // }
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error, "Login Error");
      });
  };
  // Reset Password Function
  const handleResetPasswordSubmit = (values) => {
    if (values.newPassword !== values.confirmPassword) {
      NotificationManager.error("Passwords do not match!");
      return;
    }

    const inputData = {
      email: hrmsCode,
      password: values.confirmPassword,
    };

    LoginService.ResetPassword(inputData)
      .then((response) => {
        if (response.data.statusCode === 200) {
          NotificationManager.success("Password reset successful!");
          setIsResetModalVisible(false);
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        NotificationManager.error(
          error.response?.data?.message || "Failed to reset password"
        );
      });
  };

  return (
    <div className="app-content content login_pg">
      <div className="content-wrapper">
        {!isResetModalVisible && (
          <div className="content-body">
            <section className="flexbox-container">
              <div className="col-12 d-flex align-items-center justify-content-center">
                <div className="col-md-4 col-10 box-shadow-2 p-0 login-block">
                  <div className="card border-grey border-lighten-3 px-3 pt-30 pb-2 m-0">
                    <div className="kanck_logo text-center">
                      <img src={KnackLogo} alt="logo" className="w-25" />
                    </div>
                    <div className="mt-2 border-0 login_tabs">
                      <div className="card-title text-center ">
                        <ul className="nav nav-tabs border-0 p-3 justify-content-center">
                          <li className="nav-item col-md-6">
                            <button
                              className={`nav-link ${
                                activeTab === "customer" ? "active" : ""
                              }`}
                              onClick={() => handleTabOnchange("customer")}
                            >
                              Customer
                            </button>
                          </li>
                          <li className="nav-item col-md-6">
                            <button
                              className={`nav-link ${
                                activeTab === "employee" ? "active" : ""
                              }`}
                              onClick={() => handleTabOnchange("employee")}
                            >
                              Employee
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="card-body pt-0">
                      <Form
                        form={form}
                        className="mt-4 login_form"
                        onFinish={handleLoginSubmit}
                        autoComplete="off"
                        noValidate
                      >
                        <Form.Item
                          name="email"
                          rules={[
                            {
                              required: true,
                              message:
                                activeTab === "customer"
                                  ? "Please enter your Email"
                                  : "Please enter your HRMS Code",
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  activeTab === "employee" &&
                                  value &&
                                  /[@]|gmail/i.test(value)
                                ) {
                                  return Promise.reject(
                                    new Error("Only allow HRMS Code")
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Input
                            type="text"
                            prefix={
                              <UserOutlined className="site-form-item-icon" />
                            }
                            placeholder={
                              activeTab === "customer"
                                ? "Customer Email ID"
                                : "Employee HRMS Code"
                            }
                            size="large"
                          />
                        </Form.Item>

                        <Form.Item
                          name="password"
                          rules={[
                            {
                              required: true,
                              message: "Please enter your password!",
                            },
                          ]}
                        >
                          <Input.Password
                            prefix={
                              <KeyOutlined className="site-form-item-icon" />
                            }
                            size="large"
                            placeholder="Enter Password"
                            autoComplete="new-password"
                          />
                        </Form.Item>
                        <div className="d-flex justify-content-between">
                          <Form.Item name="remember" valuePropName="checked">
                            <Checkbox
                              checked={isRememberMe}
                              onChange={(e) =>
                                setIsRememberMe(e.target.checked)
                              }
                            >
                              Remember me
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <Form.Item className="form_button">
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="login_btn w-100"
                          >
                            Submit
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}
      </div>

      {/* Reset Password Modal */}

      <Modal
        open={isResetModalVisible}
        onCancel={() => {
          setIsResetModalVisible(false);
          resetForm.resetFields();
        }}
        footer={null}
        width={470}
        centered
        bodyStyle={{
          minHeight: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        style={{
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <div className="d-flex flex-column align-items-center w-100">
          <div className="kanck_logo mb-3 text-center">
            <img
              src={KnackLogo}
              alt="logo"
              style={{ width: "20%", marginBottom: "10px" }}
            />
            <h4>Change Your Password</h4>
            <p
              className="text-center pt-2"
              style={{
                fontSize: "16px",
                color: "#555",
                width: "80%",
                textAlign: "center",
                margin: "0 auto",
              }}
            >
              Enter a new password below to change your password.
            </p>
          </div>
          <Form
            form={resetForm}
            onFinish={handleResetPasswordSubmit}
            className="mt-2 login_form"
            style={{
              width: "100%",
              maxWidth: "95%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "10%",
            }}
            layout="vertical"
          >
            <Form.Item
              name="newPassword"
              rules={[{ required: true, message: "Enter new password" }]}
              style={{ width: "100%" }}
            >
              <Input.Password
                prefix={<KeyOutlined className="site-form-item-icon" />}
                size="large"
                placeholder="New Password"
              />
            </Form.Item>

            <Form.Item
              name="confirmPassword"
              dependencies={["newPassword"]}
              rules={[
                { required: true, message: "Confirm password" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match"));
                  },
                }),
              ]}
              style={{ width: "100%" }}
            >
              <Input.Password
                prefix={<KeyOutlined className="site-form-item-icon" />}
                size="large"
                placeholder="Confirm Password"
              />
            </Form.Item>

            <Form.Item className="w-100 text-center mt-2">
              <Button
                type="primary"
                htmlType="submit"
                className="login_btn w-100"
              >
                Reset Password
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default Login;
